import React from 'react';

const WhatsAppCTA = () => {
  return (
    <section className="py-16 px-4 bg-black">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 tracking-wide">
          NOT SURE WHICH SERVICE IS FOR YOU?
        </h2>
        <p className="text-xl text-gray-400 mb-8 tracking-wider">
          GET IN TOUCH FOR MORE INFORMATION
        </p>
        <a
          href="https://wa.me/message/EPE5IIJCJKCAL1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold px-12 py-4 text-xl tracking-widest transition-colors border-4 border-white"
        >
          TEXT NOW
        </a>
      </div>
    </section>
  );
};

export default WhatsAppCTA;
